import { AxiosRequestConfig, AxiosResponse } from "axios";
import { BaseAdmin } from "./bases/base.service";

export default class AdminService {
  public getIndustry(params: any = {}): Promise<AxiosResponse<any>> {
    return BaseAdmin().get("general/industries", { params });
  }
  public getCountry(params: any = {}): Promise<AxiosResponse<any>> {
    return BaseAdmin().get("general/countries", { params });
  }
  public getProvince(params: any = {}): Promise<AxiosResponse<any>> {
    return BaseAdmin().get("general/provinces", { params });
  }
  public getCity(params: any = {}): Promise<AxiosResponse<any>> {
    return BaseAdmin().get("general/cities", { params });
  }
  public getDegree(params: any = {}): Promise<AxiosResponse<any>> {
    return BaseAdmin().get("general/degrees", { params });
  }
  public getMajor(params: any = {}): Promise<AxiosResponse<any>> {
    return BaseAdmin().get("general/majors", { params });
  }
  public getGeneralDegree(params: any = {}): Promise<AxiosResponse<any>> {
    return BaseAdmin().get("general/general-degrees", { params });
  }
  public getGeneralMajor(params: any = {}): Promise<AxiosResponse<any>> {
    return BaseAdmin().get("general/general-majors", { params });
  }
  public getSchoolType(params: any = {}): Promise<AxiosResponse<any>> {
    return BaseAdmin().get("general/school-types", { params });
  }
  public getSoftSkill(params: any = {}): Promise<AxiosResponse<any>> {
    return BaseAdmin().get("general/soft-skills", { params });
  }
  public getLanguage(params: any = {}): Promise<AxiosResponse<any>> {
    return BaseAdmin().get("general/languages", { params });
  }
  public getAdminJobFairDetail(slug: string = ""): Promise<AxiosResponse<any>> {
    return BaseAdmin().get(`admin-job-fair/landing/detail/slug/${slug}`);
  }
  public setAdminJobFairTodo(data: any): Promise<AxiosResponse<any>> {
    return BaseAdmin().post(`admin-job-fair/landing/organizer/share`, data);
  }
  public getAdminJobFairCompany(params: any = {}): Promise<AxiosResponse<any>> {
    return BaseAdmin().get(`admin-job-fair/landing/${params?.slug}/companies`, {
      params,
    });
  }
  public buyCheckAdminJobFair(params: any = {}): Promise<AxiosResponse<any>> {
    return BaseAdmin().post(
      "admin-job-fair/landing/candidate/buy/check",
      params
    );
  }
  public buyAdminJobFair(params: any = {}): Promise<AxiosResponse<any>> {
    return BaseAdmin().post("admin-job-fair/landing/candidate/buy", params);
  }
  public companyRegisterAdminJobFair(
    params: any = {}
  ): Promise<AxiosResponse<any>> {
    return BaseAdmin().post("admin-job-fair/landing/company/register", params);
  }
  public getAdminJobFairOrganizerSelf(
    params: any = {}
  ): Promise<AxiosResponse<any>> {
    return BaseAdmin().get("admin-job-fair/landing/organizer/self", { params });
  }
  public getAdminJobFairOrganizerChartAttendance(): Promise<
    AxiosResponse<any>
  > {
    return BaseAdmin().get("admin-job-fair/landing/organizer/chart/attendance");
  }
  public getAdminJobFairOrganizerChartDailyAttendance(): Promise<
    AxiosResponse<any>
  > {
    return BaseAdmin().get(
      "admin-job-fair/landing/organizer/chart/daily-attendance"
    );
  }
  public getAdminJobFairOrganizerChartCompany(): Promise<AxiosResponse<any>> {
    return BaseAdmin().get("admin-job-fair/landing/organizer/chart/company");
  }
  public getAdminJobFairOrganizerChartCategory(): Promise<AxiosResponse<any>> {
    return BaseAdmin().get("admin-job-fair/landing/organizer/chart/category");
  }
  public getAdminJobFairOrganizerChartDaily(): Promise<AxiosResponse<any>> {
    return BaseAdmin().get("admin-job-fair/landing/organizer/chart/daily");
  }
  public getAdminJobFairOrganizerChartIndustry(): Promise<AxiosResponse<any>> {
    return BaseAdmin().get("admin-job-fair/landing/organizer/chart/industry");
  }
  public getAdminJobFairOrganizerChartIndustryJob(): Promise<
    AxiosResponse<any>
  > {
    return BaseAdmin().get(
      "admin-job-fair/landing/organizer/chart/industry-job"
    );
  }
  public getAdminJobFairOrganizerChartJob(
    params: any = {}
  ): Promise<AxiosResponse<any>> {
    return BaseAdmin().get("admin-job-fair/landing/organizer/chart/job", {
      params,
    });
  }
  public getAdminJobFairOrganizerChartApplication(
    params: any = {}
  ): Promise<AxiosResponse<any>> {
    return BaseAdmin().get(
      "admin-job-fair/landing/organizer/chart/application",
      {
        params,
      }
    );
  }
  public getAdminJobFairOrganizerChartApplicationStatus(): Promise<
    AxiosResponse<any>
  > {
    return BaseAdmin().get(
      "admin-job-fair/landing/organizer/chart/application-status"
    );
  }
  public AdminJobFairOrganizerDownload(
    slug: string = ""
  ): Promise<AxiosResponse<any>> {
    return BaseAdmin().get(
      `admin-job-fair/landing/organizer/${slug}/download`,
      {
        responseType: "blob",
      }
    );
  }
  public AdminJobFairOrganizerDownloadCompanies(
    slug: string = ""
  ): Promise<AxiosResponse<any>> {
    return BaseAdmin().get(
      `admin-job-fair/landing/organizer/${slug}/download/companies`,
      {
        responseType: "blob",
        params: {
          v: Date.now(),
        },
      }
    );
  }
  public AdminJobFairOrganizerDownloadCompany(
    params: any = {}
  ): Promise<AxiosResponse<any>> {
    return BaseAdmin().get(
      `admin-job-fair/landing/organizer/company/download/${params?.id}`,
      {
        responseType: "blob",
      }
    );
  }
  public getAdminJobFairOrganizerCandidate(
    params: any = {}
  ): Promise<AxiosResponse<any>> {
    return BaseAdmin().get(
      `admin-job-fair/landing/organizer/${params?.slug}/candidates`,
      {
        params,
      }
    );
  }
  public getAdminJobFairOrganizerCandidateAppliedJobs(
    params: any = {}
  ): Promise<AxiosResponse<any>> {
    return BaseAdmin().get(
      `admin-job-fair/landing/organizer/applied-jobs/${params?.id}`,
      {
        params,
      }
    );
  }
  public getAdminJobFairOrganizerCompany(
    params: any = {}
  ): Promise<AxiosResponse<any>> {
    return BaseAdmin().get(
      `admin-job-fair/landing/organizer/${params?.slug}/companies`,
      {
        params,
      }
    );
  }
  public getAdminJobFairOrganizerCompanyJob(
    params: any = {}
  ): Promise<AxiosResponse<any>> {
    return BaseAdmin().get(
      `admin-job-fair/landing/organizer/company/jobs/${params?.id}`,
      {
        params,
      }
    );
  }
  public adminJobFairOrganizerBroadcastCandidate(
    params: any = {}
  ): Promise<AxiosResponse<any>> {
    return BaseAdmin().post(
      "admin-job-fair/landing/organizer/broadcast/candidates",
      params
    );
  }
  public adminJobFairOrganizerBroadcastCompany(
    params: any = {}
  ): Promise<AxiosResponse<any>> {
    return BaseAdmin().post(
      "admin-job-fair/landing/organizer/broadcast/companies",
      params
    );
  }
  public adminJobFairCandidateSendOtp(
    params: any = {}
  ): Promise<AxiosResponse<any>> {
    return BaseAdmin().post(
      "admin-job-fair/landing/candidate/otp/send",
      params
    );
  }
  public adminJobFairCandidateLoginCheck(
    params: any = {}
  ): Promise<AxiosResponse<any>> {
    return BaseAdmin().post("admin-job-fair/landing/candidate/check", params);
  }
  public adminJobFairCandidateLogin(
    params: any = {}
  ): Promise<AxiosResponse<any>> {
    return BaseAdmin().post("admin-job-fair/landing/candidate/login", params);
  }
  public getAdminJobFairCandidateProfile(
    params: any = {}
  ): Promise<AxiosResponse<any>> {
    return BaseAdmin().get("admin-job-fair/landing/candidate/profile", {
      params,
    });
  }
  public getAdminJobFairCandidateCompanyDetail(
    jobFairSlug: string = "",
    slug: string = ""
  ): Promise<AxiosResponse<any>> {
    return BaseAdmin().get(
      `admin-job-fair/landing/candidate/company/${jobFairSlug}/${slug}/detail`
    );
  }
  public getAdminJobFairCandidateCompanyJob(
    params: any = {}
  ): Promise<AxiosResponse<any>> {
    return BaseAdmin().get(
      `admin-job-fair/landing/candidate/company/${params?.jobFairSlug}/${params?.slug}/jobs`,
      {
        params,
      }
    );
  }
  public adminJobFairCandidateApply(
    params: any = {}
  ): Promise<AxiosResponse<any>> {
    return BaseAdmin().post("admin-job-fair/landing/candidate/apply", params);
  }
  public getAdminJobFairCompanySelf(
    params: any = {}
  ): Promise<AxiosResponse<any>> {
    return BaseAdmin().get("admin-job-fair/landing/company/self", { params });
  }
  public getAdminJobFairCompanySection(): Promise<AxiosResponse<any>> {
    return BaseAdmin().get("admin-job-fair/landing/company/sections");
  }
  public getAdminJobFairCompanyDetail(): Promise<AxiosResponse<any>> {
    return BaseAdmin().get(`admin-job-fair/landing/company/detail`);
  }
  public adminJobFairCompanyDownload(): Promise<AxiosResponse<any>> {
    return BaseAdmin().get(`admin-job-fair/landing/company/download`, {
      responseType: "blob",
    });
  }
  public adminJobFairCompanyDownloadJobs(): Promise<AxiosResponse<any>> {
    return BaseAdmin().get(`admin-job-fair/landing/company/download/jobs`, {
      responseType: "blob",
    });
  }
  public adminJobFairCompanyDownloadJob(
    params: any = {}
  ): Promise<AxiosResponse<any>> {
    return BaseAdmin().get(
      `admin-job-fair/landing/company/download/job/${params?.id}`,
      {
        responseType: "blob",
      }
    );
  }
  public getAdminJobFairCompanyJob(
    params: any = {}
  ): Promise<AxiosResponse<any>> {
    return BaseAdmin().get(`admin-job-fair/landing/company/jobs`, { params });
  }
  public adminJobFairAddJob(params: any = {}): Promise<AxiosResponse<any>> {
    return BaseAdmin().post(`admin-job-fair/landing/company/job/add`, params);
  }
  public adminJobFairEditJob(params: any = {}): Promise<AxiosResponse<any>> {
    return BaseAdmin().post(`admin-job-fair/landing/company/job/edit`, params);
  }
  public adminJobFairDeleteJob(params: any = {}): Promise<AxiosResponse<any>> {
    return BaseAdmin().delete(
      `admin-job-fair/landing/company/job/delete/${params?.id}`
    );
  }
  public getAdminJobFairJobApplicant(
    params: any = {}
  ): Promise<AxiosResponse<any>> {
    return BaseAdmin().get(
      `admin-job-fair/landing/company/applicants/${params?.id}`,
      {
        params,
      }
    );
  }
  public adminJobFairApplicantReview(
    params: any = {}
  ): Promise<AxiosResponse<any>> {
    return BaseAdmin().get(
      `admin-job-fair/landing/company/review/${params?.id}`,
      params
    );
  }
  public adminJobFairApplicantInvite(
    params: any = {}
  ): Promise<AxiosResponse<any>> {
    return BaseAdmin().post(`admin-job-fair/landing/company/invite`, params);
  }
  public adminJobFairApplicantReject(
    params: any = {}
  ): Promise<AxiosResponse<any>> {
    return BaseAdmin().post(`admin-job-fair/landing/company/reject`, params);
  }
  public adminJobFairApplicantApprove(
    params: any = {}
  ): Promise<AxiosResponse<any>> {
    return BaseAdmin().post(`admin-job-fair/landing/company/approve`, params);
  }
  public getAdminJobFairCompanyVisitor(
    params: any = {}
  ): Promise<AxiosResponse<any>> {
    return BaseAdmin().get(`admin-job-fair/landing/company/visitors`, {
      params,
    });
  }
  public getAdminJobFairCompanyCandidateAppliedJobs(
    params: any = {}
  ): Promise<AxiosResponse<any>> {
    return BaseAdmin().get(
      `admin-job-fair/landing/company/applied-jobs/${params?.id}`,
      { params }
    );
  }
  public getCandidateCv<T = any>(params: any = {}) {
    return BaseAdmin().get<T>("admin-job-fair/landing/candidate/get-cv", { params });
  }
  public adminJobFairDownloadAllCv<T = any>(
    id: any = {},
    config?: AxiosRequestConfig
  ) {
    return BaseAdmin().get<T>(`admin-job-fair/landing/company/download-all-cv/${id}`, config);
  }
  public adminJobFairDownloadCv<T = any>(
    id: any = {},
    config?: AxiosRequestConfig
  ) {
    return BaseAdmin().get<T>(`admin-job-fair/landing/company/download-cv/${id}`, config);
  }
}
